import React from 'react';
import { Helmet } from 'react-helmet';

function GoogleAnalytics() {
  if (process.env.REACT_APP_MODE !== "production") {
    return null;
  }

  return (
    <>
      {/* <Helmet> */}
        {/* / GOOGLE TAG MANAGER / */}
        {/* <script>
          {`
          (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${process.env.REACT_APP_GOOGLE_TAG_MANAGER}');`}
        </script> */}
        {/* / GOOGLE ANALYTICS / */}
        {/* <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS}`}
        /> */}
        {/* <script>
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("js", new Date());
          gtag("config", "${process.env.REACT_APP_GOOGLE_ANALYTICS}");
        `}
        </script> */}
      {/* </Helmet> */}
      {/* Google Tag Manager - BODY (noscript) */}
      {/* <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GOOGLE_TAG_MANAGER}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript> */}
    </>
  );
  return null
}

export default GoogleAnalytics;